import { DefaultButton } from '@/components/Buttons/DefaultButton';
import { useRouter } from 'expo-router';

export const BackButton = ({fallback = '/', ...rest}) => {
    const router = useRouter();
    const onPress = () => router.canGoBack() ? router.back() : router.navigate(fallback);
    
    return <DefaultButton onPress={onPress} icon={'chevron-left'} {...rest} />

}